import { render, staticRenderFns } from "./RequireList.vue?vue&type=template&id=303018f8&"
import script from "./RequireList.vue?vue&type=script&lang=js&"
export * from "./RequireList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports